<template>
  <div class="merchant-login-layout">
    <NuxtPage :page-key="(route) => route.fullPath" />
  </div>
</template>

<style lang="scss" scoped>
.merchant-login-layout {
  min-height: 100vh;
  background: rgb(var(--v-theme-background));
}
</style>
